import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { GatewayBearerInterceptor } from 'src/core/interceptor/gateway-bearer.interceptor';
import { AnonymousGatewayBearerInterceptor } from 'src/core/interceptor/anonymous-gateway-bearer.interceptor';
import { LogsAppKeyInterceptor } from 'src/core/interceptor/logs-app-key.interceptor';
import { ErrorInterceptor, JwtInterceptor } from './services/auth/helpers';
import { LayoutComponent } from './shells/public/layout/layout.component';
import { UnauthorizedComponent } from './shells/system/unauthorized/unauthorized.component';
import { P404Component } from './shells/system/p404/p404.component';
import { LoginComponent } from './auth/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecoverpasswordComponent } from './auth/recoverpassword/recoverpassword.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthenticatedShellComponent } from './shells/authenticated/authenticated-shell.component';
import { OperatorRouteRedirectComponent } from './shells/authenticated/operator-route-redirect.component';
import { MatButtonModule } from '@angular/material/button';
import { ModalCallToActionComponent } from './shells/authenticated/modal-call-to-action.component';
import { ExcelService } from './services/export/excel.service';
import { ModalPerfilComponent } from './shells/authenticated/modal-perfil.component';
import { MenuService } from './services/menu/menu-service';
import { ModalConfirmarCerrarSessionComponent } from './shells/authenticated/modal-confirmar-cerrar-session.component';
import { PerfilUsuarioComponent } from './account/perfil-usuario/perfil-usuario.component';
import { PerfilUsuarioDetalleComponent } from './account/perfil-usuario/perfil-usuario-detalle/perfil-usuario-detalle.component';
import { PerfilUsuarioModifiComponent } from './account/perfil-usuario/perfil-usuario-modifi/perfil-usuario-modifi.component';
import { PerfilUsuarioChangeOkComponent } from './account/perfil-usuario/perfil-usuario-change-ok/perfil-usuario-change-ok.component';
import { CambiarPasswordComponent } from './account/cambiar-password/cambiar-password.component';
import { CambiarPasswordModifiComponent } from './account/cambiar-password/cambiar-password-modifi/cambiar-password-modifi.component';
import { CambiarPasswordOkComponent } from './account/cambiar-password/cambiar-password-ok/cambiar-password-ok.component';
import { NotificacionesComponent } from './account/notificaciones/notificaciones.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { NgPipesModule } from 'ngx-pipes';
import { LoaderInterceptorService } from 'src/core/interceptor/loader.interceptor';
import { SolicitarClaveComponent } from './auth/solicitar-clave/solicitar-clave.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { MatStepperModule } from '@angular/material/stepper';
import { CommonModule } from '@angular/common';
import { PedidoPendienteComponent } from './profiles/aridos-mixer/despacho/components/pedido-pendiente.component';
import { EnviosPendientesListComponent } from './profiles/aridos-mixer/despacho/components/envios-pendientes-list/envios-pendientes-list.component';
import { PendingOperationEditDialogComponent } from './profiles/aridos-mixer/despacho/components/envios-pendientes-list/pending-operation-edit-dialog.component';
import { PedidoPendienteDetalleComponent } from './profiles/aridos-mixer/despacho/components/pedido-pendiente-detalle/pedido-pendiente-detalle.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { PedidosPendienteFiltroComponent } from './profiles/aridos-mixer/despacho/components/pedidos-pendiente-filtro/pedidos-pendiente-filtro.component';
import { PedidosPendienteVisualizarguiaComponent } from './profiles/aridos-mixer/despacho/components/pedidos-pendiente-visualizarguia/pedidos-pendiente-visualizarguia.component';
import { PedidosPendienteObservacionesComponent } from './profiles/aridos-mixer/despacho/components/pedido-pendiente-detalle/pedidos-pendiente-observaciones/pedidos-pendiente-observaciones.component';
import { PedidosPendienteQrComponent } from './profiles/aridos-mixer/despacho/components/pedido-pendiente-detalle/pedidos-pendiente-qr/pedidos-pendiente-qr.component';
import { PaperGuideCameraComponent } from './profiles/aridos-mixer/despacho/components/pedido-pendiente-detalle/paper-guide-camera/paper-guide-camera.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { RechazoCamionComponent } from './profiles/aridos-mixer/despacho/components/rechazo-camion/rechazo-camion.component';
import { MatOptionModule } from '@angular/material/core';
import { HormigonPedidoPendienteComponent } from './profiles/hormigon-mixer/despacho/components/pedido-pendiente.component';
import { HormigonDispatchCardComponent } from './profiles/hormigon-mixer/despacho/components/hormigon-dispatch-card/hormigon-dispatch-card.component';
import { HormigonOtrosDespachosComponent } from './profiles/hormigon-mixer/otros-despachos/hormigon-otros-despachos.component';
import { HormigonEnviosPendientesListComponent } from './profiles/hormigon-mixer/despacho/components/envios-pendientes-list/envios-pendientes-list.component';
import { HormigonPendingOperationEditDialogComponent } from './profiles/hormigon-mixer/despacho/components/envios-pendientes-list/pending-operation-edit-dialog.component';
import { HormigonPedidosPendienteVisualizarguiaComponent } from './profiles/hormigon-mixer/despacho/components/pedidos-pendiente-visualizarguia/pedidos-pendiente-visualizarguia.component';
import { HormigonPaperGuideCameraComponent } from './profiles/hormigon-mixer/despacho/components/paper-guide-camera/paper-guide-camera.component';
import { HormigonRechazoCamionComponent } from './profiles/hormigon-mixer/despacho/components/rechazo-camion/rechazo-camion.component';
import { HormigonFirmaDigitalPageComponent } from './profiles/hormigon-mixer/despacho/firma-digital-page/hormigon-firma-digital-page.component';
import { HormigonFirmaPadModalComponent } from './profiles/hormigon-mixer/despacho/firma-digital-page/hormigon-firma-pad-modal.component';
import { HormigonFirmaDatosModalComponent } from './profiles/hormigon-mixer/despacho/firma-digital-page/hormigon-firma-datos-modal.component';
import { PedidosPendienteFirmaComponent } from './profiles/aridos-mixer/despacho/components/pedido-pendiente-detalle/pedidos-pendiente-firma/pedidos-pendiente-firma.component';


import { OrderService } from './services/pedidos/pedidos.service';
import { GeolocationService } from './services/geolocation/geolocation.service';
import { ChatComponent } from './shells/authenticated/chat/chat.component';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ToastComponent } from './shared/toast/toast.component';
import { ModalInfoComponent } from './shared/modal-info/modal-info.component';
import { RouterModule } from '@angular/router';
import { HormigonMixerDashboardEntryComponent } from './profiles/hormigon-mixer/dashboard/hormigon-mixer-dashboard-entry.component';
import { AridosMixerDashboardEntryComponent } from './profiles/aridos-mixer/dashboard/aridos-mixer-dashboard-entry.component';
import { HormigonDashboardComponent } from './profiles/hormigon-mixer/dashboard/hormigon-dashboard.component';
import { AridosDashboardComponent } from './profiles/aridos-mixer/dashboard/aridos-dashboard.component';
import { HormigonMixerHistoryEntryComponent } from './profiles/hormigon-mixer/historial/hormigon-mixer-history-entry.component';
import { AridosMixerHistoryEntryComponent } from './profiles/aridos-mixer/historial/aridos-mixer-history-entry.component';
import { HormigonHistoryComponent } from './profiles/hormigon-mixer/historial/hormigon-history.component';
import { HormigonHistoryDetailComponent } from './profiles/hormigon-mixer/historial/components/hormigon-history-detail.component';
import { AridosHistoryComponent } from './profiles/aridos-mixer/historial/aridos-history.component';
import { AridosHistoryDetailComponent } from './profiles/aridos-mixer/historial/components/aridos-history-detail.component';
import { HistoryFilesViewerComponent } from './shared/history-files-viewer/history-files-viewer.component';
import { SharedUiModule } from './shared/shared-ui.module';
import { HormigonFirmaDigitalModule } from './profiles/hormigon-mixer/despacho/firma/hormigon-firma-digital.module';
import { AridosFirmaDigitalModule } from './profiles/aridos-mixer/despacho/firma/aridos-firma-digital.module';
// Add OwlModule to imports at below section

@NgModule({
  exports: [
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatStepperModule,
    MatOptionModule,
    ToastComponent,
    ModalInfoComponent,
    // SuccessDialogComponent

  ],
  imports: [
    CommonModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
    MatIconModule
  ],
  declarations: [ToastComponent, ModalInfoComponent],
})
export class MaterialModule { }

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LayoutComponent,
    UnauthorizedComponent,
    P404Component,
    RecoverpasswordComponent,
    AuthenticatedShellComponent,
    OperatorRouteRedirectComponent,
    ModalCallToActionComponent,
    ModalPerfilComponent,
    ModalConfirmarCerrarSessionComponent,
    PerfilUsuarioComponent,
    PerfilUsuarioDetalleComponent,
    PerfilUsuarioModifiComponent,
    PerfilUsuarioChangeOkComponent,
    CambiarPasswordComponent,
    CambiarPasswordModifiComponent,
    CambiarPasswordOkComponent,
    NotificacionesComponent,
    SolicitarClaveComponent,
    PedidoPendienteComponent,
    EnviosPendientesListComponent,
    PendingOperationEditDialogComponent,
    PedidoPendienteDetalleComponent,
    PedidosPendienteFiltroComponent,
    PedidosPendienteVisualizarguiaComponent,
    PedidosPendienteObservacionesComponent,
    PedidosPendienteQrComponent,
    PedidosPendienteFirmaComponent,
    PaperGuideCameraComponent,
    RechazoCamionComponent,
    ChatComponent,
    HormigonMixerDashboardEntryComponent,
    AridosMixerDashboardEntryComponent,
    HormigonDashboardComponent,
    AridosDashboardComponent,
    HormigonMixerHistoryEntryComponent,
    AridosMixerHistoryEntryComponent,
    HormigonHistoryComponent,
    HormigonHistoryDetailComponent,
    AridosHistoryComponent,
    AridosHistoryDetailComponent,
    HistoryFilesViewerComponent,
    HormigonPedidoPendienteComponent,
    HormigonDispatchCardComponent,
    HormigonOtrosDespachosComponent,
    HormigonEnviosPendientesListComponent,
    HormigonPendingOperationEditDialogComponent,
    HormigonPedidosPendienteVisualizarguiaComponent,
    HormigonPaperGuideCameraComponent,
    HormigonRechazoCamionComponent,
    HormigonFirmaDigitalPageComponent,
    HormigonFirmaPadModalComponent,
    HormigonFirmaDatosModalComponent,
  ],
  imports: [
    BrowserModule,
    NgPipesModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatSelectModule,
    MatOptionModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MaterialModule,
    MatInputModule,
    MatFormFieldModule,
    MatMomentDateModule,
    MatStepperModule,
    CommonModule,
    GoogleMapsModule,
    QRCodeComponent,
    RouterModule,
    BaseChartDirective,
    CommonModule,
    SharedUiModule,
    HormigonFirmaDigitalModule,
    AridosFirmaDigitalModule
  ],
  providers: [
    provideCharts(withDefaultRegisterables()),
    Title,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: GatewayBearerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AnonymousGatewayBearerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LogsAppKeyInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CL' },
    ExcelService,
    MenuService,
    OrderService,
    GeolocationService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
